import styled, { css, keyframes } from 'styled-components'

import { textOverflowStyles } from 'common/styles/textOverflow'
import { BoxShadow, Colors } from 'common-constants/colors'
import { media } from 'components/presentational'

const defaultHeight = 38

export const StyledAlertContainer = styled.div<{
  $isVisible: boolean
}>`
  position: absolute;
  bottom: 100%;
  width: 100%;
  padding: 10px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: ${defaultHeight}px;
  ${({ $isVisible }) =>
    !$isVisible &&
    css`
      transform: translateY(1000px);
    `};
  transition: transform 0.6s cubic-bezier(0.68, -0.55, 0.27, 1.55);
  z-index: 2;
`

export const StyledAlertBaloon = styled.div`
  border-radius: 10px;
  box-shadow: ${BoxShadow.BorderMedium};
  background-color: ${Colors.warning};
  color: ${Colors.white};
  fill: ${Colors.white};
  padding: 7px 12px;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
`

export const StyledAlertMessage = styled.div`
  margin-left: 10px;
`

export const dotsBlink = keyframes`
  0% {
    opacity: .1;
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: .1;
  }
`

const sizeDots = 4

export const UserTypingWrapper = styled.div`
  position: relative;
`

export const WrapperDots = styled.div`
  display: flex;
  ${(props) => props.theme.marginLeft}: 5px;
`

interface TypingContainerProps {
  $isTyping: boolean
}

export const TypingContainer = styled.div<TypingContainerProps>`
  display: flex;
  align-items: center;
  opacity: ${(props) => (props.$isTyping ? 1 : 0)};
  transition: opacity ease 300ms;
  position: absolute;
  left: 0;
  top: 0;

  & span {
    height: ${sizeDots}px;
    width: ${sizeDots}px;
    border-radius: ${sizeDots}px;
    background-color: ${Colors.location};
    animation-name: ${dotsBlink};
    animation-duration: 1.4s;
    animation-iteration-count: infinite;
    animation-fill-mode: both;
    margin: 0 1px;
  }

  & span:nth-child(2) {
    animation-delay: 0.2s;
  }

  & span:nth-child(3) {
    animation-delay: 0.4s;
  }
`

interface LocationContainerProps {
  $isTyping: boolean
}

export const HideIfTypingContainer = styled.div<LocationContainerProps>`
  opacity: ${(props) => (props.$isTyping ? 0 : 1)};
  transition: opacity ease 300ms;
`

const EditorPaddingCss = css`
  padding: 20px 10px;

  ${media.tabletLarge`
    padding: 10px;
  `}
`

export const StyledEditor = styled.div`
  min-height: 78px;
  flex-shrink: 0;
  width: 100%;
  box-sizing: border-box;
  ${EditorPaddingCss};
  ${media.tabletLarge`
    min-height: 58px;
  `};
  background-color: var(--static-white);
  position: relative;
  z-index: 3;
`

export const StyledEditorBlocker = styled.div`
  box-sizing: border-box;
  background-color: var(--static-white);
  position: absolute;
  z-index: 1;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  ${EditorPaddingCss};
`

export const StyledEditorWorkspace = styled.div`
  display: flex;
  width: 835px;
  justify-content: flex-start;
  position: relative;
  margin: auto;

  @media screen and (max-width: 1250px) {
    width: 100%;
  }
`

export const TEXTAREA_PADDING = 10

export const CustomPlaceholder = styled.div<{ left?: number }>`
  position: absolute;
  inset: ${TEXTAREA_PADDING}px ${TEXTAREA_PADDING}px ${TEXTAREA_PADDING}px
    ${({ left }) => left || TEXTAREA_PADDING}px;
  pointer-events: none;
  ${textOverflowStyles};
  color: ${Colors.inputPlaceholderColor};
`
